<template>
  <div class="page">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'Page',
};

</script>

<style lang='scss' scoped>
@import "~@/assets/scss/colors";
.page {
  background-color: $white;
  font-size: 13px;
  font-family: 'Times New Roman', Times, serif;
  margin: 0;
  box-sizing: border-box;
  page-break-after: always;
  height: 310mm;
  width: 220mm;
  padding: 10mm 12mm 10mm 12mm;
  border-bottom: 1px solid $alto;
  position: relative;

  &:last-child {
    border: 0;
  }

  .working-hours {
    padding: 10px 15px;
    padding-bottom: 12px;
    background-color: $paradisePink;
    color: $white;
    text-align: center;
    font-style: italic;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    font-size: 12px;
  }
}
</style>
